import React, { useState } from 'react';

import { Toaster,toast } from 'react-hot-toast';

const Contact = () => {
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      message: ''
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
        const response = await fetch('https://apiformcontacto.azurewebsites.net/Contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const result = await response.json();
        toast({
          title: "Mensaje enviado",
          description: "Nos pondremos en contacto contigo pronto.",
        });
      } catch (error) {
        toast({
          title: "Error",
          description: "Hubo un problema al enviar tu mensaje.",
        });
      }
    };
    return (
        <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-poppins font-bold text-aulanovus-blue mb-8 text-center">Contacto</h1>
        <div className="max-w-2xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Tu nombre"
                required
                onChange={handleChange}
                value={formData.name}
              />
            </div>
  
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="tu@email.com"
                required
                onChange={handleChange}
                value={formData.email}
              />
            </div>
  
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
              <textarea
                id="message"
                name="message"
                placeholder="¿En qué podemos ayudarte?"
                className="min-h-[150px]"
                required
                onChange={handleChange}
                value={formData.message}
              />
            </div>
  
            <button type="submit" className="w-full bg-aulanovus-blue hover:bg-blue-800">
              Enviar mensaje
            </button>
          </form>
        </div>
        <Toaster />
      </div>
    );
};

export default Contact;